import { recordTrack } from '@saucelabs/sl-util-segmentio';

import { TEST_DETAILS_TAB_INTERACTIONS } from './ducks/container/constants';
import { checkIsAndroid } from './ducks/errorReport/utils';
import { APP_STORAGE_KIND } from './constants';

export const TEST_DETAILS_TRACKING_DEFAULT_PROPS = Object.freeze({
  product_area: 'Test Details',
});
export const LEGACY_PREFIX = 'Test Details';
const MANUAL_TEST_DETAILS_PREFIX = 'Manual Test Details - ';
const TEST_DETAILS_PREFIX = 'Test Details - ';

export const CTA_EVENTS = Object.freeze({
  PLAY_VIDEO: `${TEST_DETAILS_PREFIX}Play Video`,
  DOWNLOAD_LOGS: `${LEGACY_PREFIX} - Download Logs`,
  DOWNLOAD_VIDEO: `${LEGACY_PREFIX} - Download VIDEO`,
});

export const JOB_DETAILS_LEGACY_EVENTS = Object.freeze({
  PAGE_OPEN: `${LEGACY_PREFIX} Page Open`,
  ENTERED_FULLSCREEN: `${LEGACY_PREFIX} Entered Fullscreen`,
  KEBAB_MENU_OPENED: `${LEGACY_PREFIX} Kebab Menu Opened`,
});

export const JOB_DETAILS_EVENTS = Object.freeze({
  OBJECT_CLICKED: 'Object Clicked',

  // Legacy events
  EXPIRED_ASSETS: `${TEST_DETAILS_PREFIX}Show Expired Assets Notification`,
  MANUAL_TEST_DETAILS_SHOW_DEVICE_LOGS: `${MANUAL_TEST_DETAILS_PREFIX}Show Device Logs`,
  MANUAL_TEST_DETAILS_SHOW_METADATA: `${MANUAL_TEST_DETAILS_PREFIX}Show Metadata`,
  MANUAL_TEST_DETAILS_DOWNLOAD_VIDEO: `${MANUAL_TEST_DETAILS_PREFIX}Download Video`,
  MANUAL_TEST_DETAILS_DOWNLOAD_DEVICE_LOGS: `${MANUAL_TEST_DETAILS_PREFIX}Download Device Logs`,
  TOGGLE_DASHBOARD: `${TEST_DETAILS_PREFIX}Toggle Dashboard`,
});

export const NAVIGATION_EVENTS = Object.freeze({
  TEST_DETAILS_TABS: Object.freeze({
    commands: `${TEST_DETAILS_PREFIX}Show Commands`,
    logs: `${TEST_DETAILS_PREFIX}Show Logs`,
    metadata: `${TEST_DETAILS_PREFIX}Show Metadata`,
    'test cases': `${TEST_DETAILS_PREFIX}Show Test Cases`,
  }),
});

export const JOB_DETAILS_SUBJECT_NAMES = Object.freeze({
  BACKTRACE_DASHBOARD: 'Backtrace Dashboard',
  CONFIGURE_BACKTRACE: 'Configure Backtrace',
  DEVICE_VITALS: 'Device Vitals',
  DEVICE_INTERACTIONS: 'Device Interactions',
  ERROR_CRASH_TAB: 'Error Crash Tab',
  LINK_WITH_BACKTRACE: 'Link with Backtrace',
  SIGN_UP_WITH_BACKTRACE: 'Sign Up with Backtrace',
  VIEW_BACKTRACE_CRASHES: 'View Backtrace Crashes',
  VIEW_BACKTRACE_ERRORS: 'View Backtrace Errors',
  VIEW_TREE_INSPECTOR: 'ViewTree',
});

export const JOB_DETAILS_PRODUCT_AREAS = Object.freeze({
  BACKTRACE: 'Backtrace',
  MOBILE: 'Mobile',
});

export const JOB_DETAILS_PRODUCT_SUB_AREAS = Object.freeze({
  ERROR_REPORTING_TAB_IN_AUTOMATED_SAUCE_LABS: 'Error Reporting Tab in AUTOMATED Sauce Labs',
  ERROR_REPORTING_TAB_IN_LIVE_SAUCE_LABS: 'Error Reporting Tab in Live Sauce Labs',
  MOBILE_APP_DIAGNOSTICS: 'MOBILE_APP_DIAGNOSTICS',
});

export const JOB_COMMANDS_EVENTS = Object.freeze({
  EXPAND: 'Job Details - Expand Command',
  COLLAPSE: 'Job Details - Collapse Command',
});

export const API_DEVICE_TYPE_TO_TRACKING_DEVICE_TYPE_CONVERSION = Object.freeze({
  realdevice: 'rdc',
  vm: 'vdc',
});

export const trackTabsClick = (job, interactionsCount) => (eventKey) => {
  switch (eventKey) {
    case Object.keys(NAVIGATION_EVENTS.TEST_DETAILS_TABS).includes(eventKey):
      recordTrack(
        NAVIGATION_EVENTS.TEST_DETAILS_TABS[eventKey], {
          ...TEST_DETAILS_TRACKING_DEFAULT_PROPS,
          isRdc: job.isRdc(),
          jobType: job.getJobType(),
        },
      );
      break;
    case TEST_DETAILS_TAB_INTERACTIONS:
      recordTrack(JOB_DETAILS_EVENTS.OBJECT_CLICKED, {
        subject_name: JOB_DETAILS_SUBJECT_NAMES.DEVICE_INTERACTIONS,
        product_area: JOB_DETAILS_PRODUCT_AREAS.MOBILE,
        product_sub_area: JOB_DETAILS_PRODUCT_SUB_AREAS.MOBILE_APP_DIAGNOSTICS,
        app_kind: checkIsAndroid(job) ? APP_STORAGE_KIND.ANDROID : APP_STORAGE_KIND.IOS,
        empty_state: interactionsCount === 0,
        test_type: job.getJobType(),
      });
      break;
    default:
      break;
  }
};

export const JOB_DETAILS_EDIT_EVENTS = Object.freeze({
  OPEN_EDIT_INLINE: 'Test Details - Test Name Edit Open',
  OPEN_EDIT_GLOBAL: 'Test Details - Edit Open',
  SAVE_TEST_DETAILS: 'Test Details - Edit Save Button',
});

export const LIVE_TESTING_EVENTS = Object.freeze({
  OBJECT_CLICKED: 'Object Clicked',
});

export const LIVE_TESTING_TRACKING_PROPS = Object.freeze({
  product_area: 'Live Testing',
});

export const LIVE_TESTING_PRODUCT_SUB_AREAS = Object.freeze({
  APP_SETTINGS: 'App Settings',
});

export const trackEvent = recordTrack;
export default trackEvent;
